/* All motion uses scrollLeft, never attributes: theme.liquid's Judge Me MutationObserver would thrash */
(function () {
  'use strict';
  var TX_UGC_BUILD = '20260908-r1';

  function init(root) {
    if (root.dataset.txUgcReady === '1') return;
    root.dataset.txUgcReady = '1';
    var scroller = root.querySelector('[data-tx-ugc-scroller]');
    var track = root.querySelector('[data-tx-ugc-track]');
    if (!scroller || !track || !track.children.length) return;

    var mobile = window.matchMedia('(max-width: 767.98px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* clone the card set once so the wrap-around never shows a gap */
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });

    function setWidth() {
      // one card set + one gap = the wrap period
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var last = originals[originals.length - 1];
      setWidth.period = last.offsetLeft - originals[0].offsetLeft + last.offsetWidth + gap;
    }
    setWidth();
    addEventListener('resize', setWidth);

    /* start offset 90 (55 mobile); the drift wrap below reuses it */
    scroller.scrollLeft = mobile.matches ? 55 : 90;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.tx-ugc__dot'));
    var activeDot = 0;
    function syncDots() {
      if (!dots.length || !setWidth.period) return;
      var progress = (scroller.scrollLeft % setWidth.period) / setWidth.period;
      var idx = Math.round(progress * originals.length) % dots.length;
      if (idx !== activeDot) {
        dots[activeDot].classList.remove('is-active');
        dots[activeDot].setAttribute('aria-current', 'false');
        dots[idx].classList.add('is-active');
        dots[idx].setAttribute('aria-current', 'true');
        activeDot = idx;
      }
    }
    scroller.addEventListener('scroll', syncDots, { passive: true });

    var paused = false;
    var manualUntil = 0;
    var touching = false;
    function pauseManual() { manualUntil = Date.now() + 6000; }
    function goTo(i) {
      pauseManual();
      var n = originals.length;
      i = ((i % n) + n) % n;
      scroller.scrollLeft = originals[i].offsetLeft - originals[0].offsetLeft;
      pos = scroller.scrollLeft;
      syncDots();
    }
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    var prev = root.querySelector('[data-tx-ugc-prev]');
    var next = root.querySelector('[data-tx-ugc-next]');
    if (prev) prev.addEventListener('click', function () { goTo(activeDot - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeDot + 1); });
    root.addEventListener('focusin', pauseManual);
    scroller.addEventListener('touchstart', function () { touching = true; pauseManual(); }, { passive: true });
    function endTouch() { touching = false; pauseManual(); }
    scroller.addEventListener('touchend', endTouch, { passive: true });
    scroller.addEventListener('touchcancel', endTouch, { passive: true });
    scroller.addEventListener('wheel', pauseManual, { passive: true });
    var inView = true;
    /* keep the observer referenced: an unreferenced one is collected and the rail never drifts */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      });
      io.observe(scroller);
    }
    scroller.addEventListener('mouseenter', function () { paused = true; });
    scroller.addEventListener('mouseleave', function () { paused = false; });

    /* accumulate in pos, not scrollLeft: scrollLeft rounds to whole pixels so +0.4 steps never add up */
    var pos = scroller.scrollLeft;
    function drift() {
      /* reduced motion is read inside the loop so an OS toggle applies without a reload */
      if (!paused && !touching && Date.now() >= manualUntil && inView && !dragging && !document.hidden && !reduced.matches) {
        pos += 0.4;
        if (pos >= setWidth.period + (mobile.matches ? 55 : 90)) pos -= setWidth.period;
        scroller.scrollLeft = pos;
      } else {
        pos = scroller.scrollLeft;
      }
      requestAnimationFrame(drift);
    }
    requestAnimationFrame(drift);

    /* pointer drag (desktop; mobile uses native touch scroll) */
    var dragging = false;
    var dragMoved = false;
    var startX = 0;
    var startLeft = 0;
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      dragging = true;
      pauseManual();
      dragMoved = false;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });
    addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) dragMoved = true;
      scroller.scrollLeft = startLeft - dx;
    });
    addEventListener('pointerup', function () {
      dragging = false;
      scroller.classList.remove('is-dragging');
    });
    addEventListener('pointercancel', function () { dragging = false; scroller.classList.remove('is-dragging'); });

    scroller.addEventListener('scroll', function () {
      if (!setWidth.period) return;
      if (!touching && !dragging && Date.now() >= manualUntil) {
        if (scroller.scrollLeft >= setWidth.period * 1.5) scroller.scrollLeft -= setWidth.period;
      }
    }, { passive: true });

    var box = root.querySelector('[data-tx-ugc-lightbox]');
    if (!box || typeof box.showModal !== 'function') return;
    var boxPhoto = box.querySelector('[data-tx-ugc-box-photo]');
    var boxUser = box.querySelector('[data-tx-ugc-box-username]');
    var boxInitials = box.querySelector('[data-tx-ugc-box-initials]');
    var boxReview = box.querySelector('[data-tx-ugc-box-review]');
    var opener = null;

    function open(card) {
      boxPhoto.src = card.getAttribute('data-photo');
      boxUser.textContent = card.getAttribute('data-username');
      boxInitials.textContent = card.getAttribute('data-initials');
      var tpl = card.querySelector('[data-tx-ugc-review]');
      boxReview.innerHTML = '<strong>' + card.getAttribute('data-username') + '</strong> ';
      if (tpl) boxReview.innerHTML += tpl.innerHTML.replace(/<\/?p[^>]*>/g, ' ');
      opener = card;
      paused = true; /* stop the rail drifting under the modal */
      document.body.style.overflow = 'hidden';
      box.showModal();
    }
    function close() {
      box.close();
    }
    box.addEventListener('close', function () {
      paused = false;
      document.body.style.overflow = '';
      if (opener) opener.focus();
    });
    box.addEventListener('click', function (e) {
      // dialog itself = the scrim; panel clicks stay inside child elements
      if (e.target === box) close();
    });
    box.querySelector('[data-tx-ugc-close]').addEventListener('click', close);

    /* scrollLeft always moves, so a tap is judged by pointer travel; pointercancel counts as a swipe */
    var tapX = 0, tapY = 0, tapMoved = false;
    scroller.addEventListener('pointerdown', function (e) {
      tapX = e.clientX; tapY = e.clientY; tapMoved = false;
    }, { passive: true });
    scroller.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - tapX) > 10 || Math.abs(e.clientY - tapY) > 10) tapMoved = true;
    }, { passive: true });
    scroller.addEventListener('pointercancel', function () { tapMoved = true; }, { passive: true });

    track.addEventListener('click', function (e) {
      if (dragMoved || tapMoved) return;
      var card = e.target.closest('[data-tx-ugc-card]');
      if (card) open(card);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-tx-ugc-card]');
      if (card) { e.preventDefault(); open(card); }
    });
  }

  document.querySelectorAll('[data-tx-ugc]').forEach(init);
})();
